import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingSearch01 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.5609 28.439L25.3279 23.206C26.6405 21.3613 27.2121 19.0907 26.9293 16.8444C26.6465 14.5981 25.53 12.54 23.8011 11.0782C22.0723 9.61632 19.8573 8.85742 17.5952 8.9519C15.3331 9.04639 13.1891 9.98735 11.5882 11.5883C9.98729 13.1892 9.04633 15.3332 8.95184 17.5953C8.85736 19.8574 9.61626 22.0724 11.0781 23.8012C12.5399 25.5301 14.598 26.6465 16.8443 26.9293C19.0906 27.2121 21.3612 26.6406 23.2059 25.328L28.4389 30.561C28.7203 30.8424 29.102 31.0005 29.4999 31.0005C29.8979 31.0005 30.2796 30.8424 30.5609 30.561C30.8423 30.2796 31.0004 29.898 31.0004 29.5C31.0004 29.1021 30.8423 28.7204 30.5609 28.439ZM10.9999 18C10.9999 16.6155 11.4105 15.2622 12.1797 14.111C12.9488 12.9599 14.0421 12.0627 15.3212 11.5329C16.6002 11.003 18.0077 10.8644 19.3656 11.1345C20.7234 11.4046 21.9707 12.0713 22.9497 13.0503C23.9287 14.0292 24.5953 15.2765 24.8654 16.6344C25.1355 17.9922 24.9969 19.3997 24.4671 20.6788C23.9373 21.9579 23.0401 23.0511 21.8889 23.8203C20.7378 24.5895 19.3844 25 17.9999 25C16.1441 24.9979 14.3648 24.2597 13.0525 22.9474C11.7402 21.6351 11.0021 19.8559 10.9999 18Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMagnifyingSearch01);
export default ForwardRef;
